import { render } from "./FoodChart.vue?vue&type=template&id=fbfc88f4&ts=true"
import script from "./FoodChart.vue?vue&type=script&lang=ts"
export * from "./FoodChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__